exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".banner {\n  width: 100%; }\n\n.bg {\n  background-color: black; }\n\n.width30 {\n  width: 30%; }\n\n.width40 {\n  width: 40%; }\n\n.width50 {\n  width: 50%; }\n\n.width60 {\n  width: 60%; }\n\n.width100 {\n  width: 100%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/about/about.component.scss
// module id = 283
// module chunks = 1